import { Button } from 'antd';
import moment from 'moment';

import type { ModelProductOperation } from '@app/api/Products';
import type { GetColumnsType } from '@app/pages/Warehouses/WarehouseOperations/types';
import { divideAmount } from '@app/utils';
import { bigNumberToString } from '@app/utils/bigNumberToString';

import type { ColumnsType } from 'antd/es/table';

export const getWarehouseOperationsColumns: GetColumnsType = ({
  openProduct,
}) => {
  const columns: ColumnsType<ModelProductOperation> = [
    {
      title: 'Дата',
      dataIndex: 'Timestamp',
      key: 'Timestamp',
      width: 140,
      render: (date: string) => (
        <span className="no-wrap-text">
          {moment(date).format('DD.MM.YYYY')}
        </span>
      ),
    },
    {
      title: 'Тип операции',
      dataIndex: 'Operation',
      key: 'Operation',
      width: 110,
      render: (operation: string) => (
        <span className="no-wrap-text">{operation ?? '—'}</span>
      ),
    },
    {
      title: 'Документ №',
      dataIndex: 'DocumentId',
      key: 'DocumentId',
      width: 110,
      render: (id: number) => <span className="no-wrap-text">{id ?? '—'}</span>,
    },
    {
      title: 'Поставщик / Получатель',
      dataIndex: 'Supplier',
      key: 'Supplier',
      ellipsis: true,
      width: 200,
      render: (id: number | null) => (
        <span className="no-wrap-text">{id ?? '—'}</span>
      ),
    },
    {
      title: 'Склад',
      dataIndex: 'Warehouse',
      key: 'Warehouse',
      width: 160,
      ellipsis: true,
      render: (id: number) => (
        <span className="no-wrap-text" style={{ maxWidth: 300 }}>
          {id}
        </span>
      ),
    },
    {
      title: 'Товар',
      dataIndex: 'Product',
      key: 'Product',
      ellipsis: true,
      render: (_: unknown, row: ModelProductOperation) => (
        <Button
          type="link"
          className="no-wrap-text no-padding"
          onClick={() => openProduct(row.ProductId)}
        >
          {row.Product}
        </Button>
      ),
    },
    {
      title: 'Использование массы/объема',
      dataIndex: 'Usage',
      key: 'Usage',
      width: 80,
      render: (usage: number | null) => (
        <span className="no-wrap-text">
          {usage ? divideAmount(usage) : '—'}
        </span>
      ),
    },
    {
      title: 'Кол-во',
      dataIndex: 'CountProducts',
      key: 'CountProducts',
      width: 80,
      render: (cnt: number) => <span className="no-wrap-text">{cnt}</span>,
    },
    {
      title: 'Цена закупки',
      dataIndex: 'PriceOfPurchase',
      key: 'PriceOfPurchase',
      width: 150,
      render: (price: number) => (
        <span className="no-wrap-text">
          {Number(bigNumberToString(price)).toFixed(2)}
        </span>
      ),
    },
    {
      title: 'Остаток на складе до операции',
      dataIndex: 'CountLeftAtWarehouse',
      key: 'CountLeftAtWarehouse',
      width: 150,
    },
    {
      title: 'Пользователь',
      dataIndex: 'UserName',
      key: 'UserName',
      width: 120,
      ellipsis: true,
      render: (name: string | null) => (
        <span className="no-wrap-text">{name ?? '—'}</span>
      ),
    },
  ];

  return columns;
};
